import ReactPortal from './component'
export default ReactPortal
